import { CHARGE_POINT_REFRESH_TIMEOUT } from '../constants/ChargePointConstants'
import { useChargePointContext } from '../context/ChargePointContext'
import { useChargePointGetQuery } from '../redux/api/web-api'

const useRemoteControlAutoRefresh = (chargePointId: string) => {
    const { autoRefresh } = useChargePointContext()

    const { data: chargePoint } = useChargePointGetQuery(
        {
            chargePointId: chargePointId,
            expand: 'additionalInfo,scheduleInfo',
        },
        {
            pollingInterval: autoRefresh ? CHARGE_POINT_REFRESH_TIMEOUT : undefined,
        }
    )

    return chargePoint
}

export default useRemoteControlAutoRefresh
